
import { BaseResolver } from "@nx/typescript-domain";
import { ICalendarRepository } from "./calendars/ICalendarRepository";
import { ICalendarEventRepository } from "./calendarEvents/ICalendarEventRepository";
import { IConfigRepository } from "./config/IConfigRepository";
import { ILogRepository } from "./log/ILogRepository";
import { ICardRepository } from "./cards/ICardRepository";

export class Dependencies extends BaseResolver {
    get configRepository() { return this.resolve<IConfigRepository>("IConfigRepository"); };
    get logRepository() { return this.resolve<ILogRepository>("ILogRepository"); };
    get calendarRepository() { return this.resolve<ICalendarRepository>("ICalendarRepository"); }
    get calendarEventRepository() { return this.resolve<ICalendarEventRepository>("ICalendarEventRepository"); }
    get cardRepository() { return this.resolve<ICardRepository>("ICardRepository"); }
}
export const dependencies = new Dependencies();
